export const ApprovalAction = {
  GET_APPROVALS: "GET_APPROVALS",
  GET_APPROVALS_SUCCESS: "GET_APPROVALS_SUCCESS",
  GET_APPROVALS_FAILURE: "GET_APPROVALS_FAILURE",
};
